import { Container } from "./styles";

const ToComplete = () => {
    return (
        <Container>
            Por completar
        </Container>
    );
}

export default ToComplete;